import * as React from "react";
import { Link } from "gatsby";
import useOptions from "../hooks/useOptions";
import { breakOnPeriod } from "../util/common";

const CtaBlock = () => {
  const { footerCta } = useOptions();
  const { title, link } = footerCta;

  return <BlockWithBlueShapes title={title} link={link} />;
};

export const BlockWithBlueShapes = ({ title, link }) => {
  return (
    <div className="py-8 lg:bg-[url('/background/CAT-BG.png')] bg-[url('/background/CAT-BG-Mobile.png')] bg-cover bg-center	min-h-[300px] flex flex-col justify-items-center content-center justify-center print:hidden">
      <div className="container text-white ">
        <div className="">
          <div
            className="lg:leading-tight text-3xl lg:text-6xl font-bold  mx-auto text-center"
            dangerouslySetInnerHTML={{ __html: breakOnPeriod(title) }}
          />
          <div className=" text-center mt-12 mb-8">
            <Link
              to={link.uri}
              className="text-xl border rounded-full py-3 px-12 font-extrabold bg-white text-blue	hover:text-white hover:bg-transparent duration-300	boottom_cta_demo"
              data-cta-position='body'
            >
              {link.title}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaBlock;
